/* eslint-disable no-undef */
(function (w, d, $) {
  let resizeTimer;
  let sliders = [];
  const sliderOptions = {
    cellAlign: 'left',
    contain: true,
    groupCells: true,
    wrapAround: false,
    pageDots: false,
    prevNextButtons: true,
  };

  /**
   *
   */
  function onLoad() {
    const sliderElements = d.querySelectorAll('.js-postsliders') || [];

    sliderElements.forEach(function (sliderElement) {
      const currentList = sliderElement.querySelector('.js-postsliders-list');

      if (!currentList) {
        return;
      }

      const slider = new Flickity(currentList, sliderOptions);

      sliders.push(slider);
    });
  }

  /**
   * Recreate sliders.
   *
   * Flickity resize method seems to not work when height auto.
   * @returns {void}
   */
  function resizeSliders() {
    const tmpSliders = sliders;
    sliders = [];

    tmpSliders.forEach(function (item) {
      item.destroy();
      sliders.push(new Flickity(item.element, sliderOptions));
    });
  }

  /**
   *
   */
  function onResizeEnd() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resizeSliders, 250);
  }

  w.addEventListener('resize', onResizeEnd);
  w.addEventListener('load', onLoad);
})(window, document, jQuery);
